module.exports = __webpack_public_path__ + "static/media/CS-TW.1ad83688.png";